import { Component } from "react";
import * as Scrivito from "scrivito";
import classNames from "classnames";
import { isBrowser } from "^/utils/isBrowser";

class CheckboxOptionWidgetComponent extends Component {
  state = {
    checked: false,
  };

  componentDidMount() {
    this.getCheckedStatus();
  }

  toggleChecked = (e) => {
    this.props.handleInputChange(e, !this.state.checked);
    this.setState((prevState) => ({
      checked: !prevState.checked,
    }));
  };

  getCheckedStatus = () => {
    const { widget } = this.props;
    const checkboxWidgetId = widget.container().id();
    const value = widget.get("value");

    const myStorage = isBrowser ? window.sessionStorage : {};

    if (myStorage.getItem(checkboxWidgetId)) {
      const values = JSON.parse(myStorage.getItem(checkboxWidgetId));
      if (values.indexOf(value) !== -1) {
        this.setState((prevState) => ({
          checked: !prevState.checked,
        }));
      }
    }
  };

  render() {
    const { widget } = this.props;
    const value = widget.get("text");
    const { checked } = this.state;

    return (
      <div>
        <input
          type="checkbox"
          id={widget.id()}
          name={value}
          value={value}
          checked={checked}
          className="form-check-input"
          onChange={(e) => {
            this.props.handleCheckboxes(value, !this.state.checked);
            this.toggleChecked(e);
          }}
        />
        <label className="form-input-check-label" htmlFor={widget.id()}>
          <Scrivito.ContentTag
            className={classNames("no-margin form-confirmation")}
            tag="span"
            content={widget}
            attribute="text"
          />
        </label>
      </div>
    );
  }
}

Scrivito.provideComponent(
  "CheckboxOptionWidget",
  CheckboxOptionWidgetComponent
);

export default Scrivito.connect(CheckboxOptionWidgetComponent);
